var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { HStack, Text, VStack } from "native-base";
import { formatDateTime } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import AvatarTexts from "../AvatarTexts";
import Badge from "../../atoms/Badge";
import IconButton from "../../atoms/IconButton";
const CommentListItem = (_a) => {
    var { user, date, comment, canDelete, onDeleted } = _a, rest = __rest(_a, ["user", "date", "comment", "canDelete", "onDeleted"]);
    const { t } = useTranslation();
    const userTypes = useMemo(() => ({
        doctor: {
            name: t("attendingDoctor"),
            variant: "ghost",
        },
        patient: {
            name: t("patient"),
            variant: "ghostSuccess",
        },
    }), [t]);
    const { fullName = "", avatarUrl = "", type, monogram = "" } = user;
    return (_jsxs(VStack, Object.assign({ px: 3, py: 4, borderBottomWidth: 1, borderBottomColor: "gray.100", width: "full", bgColor: "white" }, rest, { children: [_jsxs(HStack, Object.assign({ justifyContent: "space-between" }, { children: [_jsx(AvatarTexts, { size: "lg", source: avatarUrl, hasAvatar: !!avatarUrl, initials: monogram, label: _jsxs(_Fragment, { children: [_jsx(Text, Object.assign({ isTruncated: true }, { children: fullName })), _jsx(Badge, Object.assign({ ml: 2, variant: userTypes[type].variant, hasIndicator: false }, { children: userTypes[type].name }))] }), subText: date ? formatDateTime(date) : "" }), canDelete && (_jsx(IconButton, { variant: "ghost", iconName: "trashCan", size: "xs", onPress: onDeleted }))] })), comment && (_jsx(Text, Object.assign({ ml: 11, mt: 2, numberOfLines: 99 }, { children: comment })))] })));
};
export default CommentListItem;
